/* product.js — supports Shopify variant images + alt-text multi-image grouping */

(function () {
  // ---------- small utilities ----------
  function jqReady(fn) {
    function run() {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    if (window.jQuery) run();
    else {
      var tries = 0, iv = setInterval(function () {
        if (window.jQuery) { clearInterval(iv); run(); }
        else if (++tries > 200) { clearInterval(iv); }
      }, 30);
    }
    window.addEventListener('w3-DOMContentLoaded', function(){ if (window.jQuery) fn(); }, { once: true });
  }

  function eager($img) {
    if (!$img || !$img.length) return;
    var ds = $img.attr('data-src');
    if (ds && !$img.attr('src')) { $img.attr('src', ds).removeAttr('data-src'); }
    $img.attr('decoding', 'async');
  }

  function norm(u){ if(!u) return ''; try { return u.split('?')[0].toLowerCase(); } catch(e){ return (u+'').toLowerCase(); } }

  jqReady(function () {
    var $ = window.jQuery;
    if (!$) return;

    // ---------- initialize BOTH carousels ----------
    var $carousels = $('.desktop .carousel, .mobile .carousel');
    $carousels.each(function () {
      var $c = $(this);
      if ($c.data('flickity')) return;
      var isDesktop = !!$c.closest('.desktop').length;
      $c.flickity({
        wrapAround: true,
        pageDots: false,
        cellAlign: isDesktop ? 'right' : 'center',
        prevNextButtons: true
      });
    });

    // ---------- variant mapping ----------
    function buildVariantMap() {
      var map = {};
      $('#select_variant option').each(function () {
        var $o = $(this);
        var vid = ($o.val() || '').trim();
        if (!vid) return;
        map[vid] = {
          featuredId: ($o.attr('data-featured-media-id') || '').trim(),
          image: norm($o.attr('data-image') || '')
        };
      });
      return map;
    }

    var variantMap = buildVariantMap();

    function getCurrentVariantId() {
      var hid = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (hid && hid.value) return String(hid.value).trim();
      var $sel = $('#select_variant');
      if ($sel.length) return String($sel.val() || '').trim();
      return '';
    }

    // ---------- get selected flavor key ----------
    function getSelectedAltKeyword() {
      var flavorInput = document.querySelector('input[name="Flavor"]:checked');
      var flavor = flavorInput ? flavorInput.value : '';
      if (!flavor) return '';
      return 'flavor_' + flavor.toLowerCase().replace(/\s+/g, '-');
    }

    // ---------- filter one carousel ----------
    function filterOneCarousel($carousel, featuredId, wantUrl) {
      var $cells = $carousel.find('.carousel-cell');
      if (!$cells.length) return;

      var altKey = getSelectedAltKeyword();
      var anyAltMatch = false;
      var targetEl = null;
      var firstVisibleEl = null;

      // Pass 1: show alt-tag matches + global
      $cells.each(function (_, el) {
        var $el = $(el);
        var $img = $el.find('img');
        var alt = ($img.attr('alt') || '').toLowerCase();
        var dataAltKey = ($el.attr('data-alt-key') || '').toLowerCase();
        var isGlobal = !alt.match(/flavor_/) && !dataAltKey.match(/flavor_/);
        var matchesAlt = altKey && (alt.includes(altKey) || dataAltKey.includes(altKey));

        if (matchesAlt || isGlobal) {
          $el.show();
          eager($img);
          if (!firstVisibleEl) firstVisibleEl = el;
          if (matchesAlt) anyAltMatch = true;
        } else {
          $el.hide();
        }
      });

      // Pass 2: if no alt matches, use Shopify variant logic
      if (!anyAltMatch) {
        $cells.each(function (_, el) {
          var $el = $(el);
          var $img = $el.find('img');
          var mid = ($el.attr('data-media-id') || '').trim();
          var attached = ($el.attr('data-attached') || '').toLowerCase();
          var src = norm($img.attr('src') || '');
          var dsrc = norm($img.attr('data-src') || '');
          var set = ($img.attr('srcset') || '').toLowerCase();

          var matchesFeatured =
            (featuredId && mid === featuredId) ||
            (wantUrl && (src.indexOf(wantUrl) !== -1 || dsrc.indexOf(wantUrl) !== -1 || set.indexOf(wantUrl) !== -1));

          var show = (attached === 'false') || matchesFeatured;

          if (show) {
            $el.show();
            eager($img);
            if (!firstVisibleEl) firstVisibleEl = el;
            if (matchesFeatured) targetEl = el;
          } else {
            $el.hide();
          }
        });
      }

      // Safety fallback
      var anyVisible = $cells.filter(':visible').length > 0;
      if (!anyVisible && $cells.length) {
        var first = $cells.get(0);
        $(first).show();
        eager($(first).find('img'));
        firstVisibleEl = first;
      }

      // Flickity refresh
      $carousel.flickity('reloadCells');
      $carousel.flickity('resize');

      if (targetEl) $carousel.flickity('selectCell', targetEl);
      else if (firstVisibleEl) $carousel.flickity('selectCell', firstVisibleEl);
    }

    // ---------- update all carousels ----------
    function updateGallery(reason) {
      variantMap = buildVariantMap();
      var vid = getCurrentVariantId();
      var meta = variantMap[vid] || { featuredId: '', image: '' };
      var featuredId = (meta.featuredId || '').trim();
      var wantUrl = meta.image;

      console.log('[gallery:update]', { reason: reason, variantId: vid, featuredId: featuredId });
      $carousels.each(function () {
        filterOneCarousel($(this), featuredId, wantUrl);
      });
    }

    // ---------- listeners ----------
    $(document).on('change', '#select_variant', function(){ updateGallery('select:change'); });

    (function watchHiddenId(){
      var hid = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!hid) return;
      function sync(reason){ updateGallery(reason); }
      hid.addEventListener('input',  function(){ sync('hidden:input');  });
      hid.addEventListener('change', function(){ sync('hidden:change'); });
      var mo = new MutationObserver(function(){ sync('hidden:mutation'); });
      mo.observe(hid, { attributes: true, attributeFilter: ['value'] });
    })();

    ['variant:change','variant:changed','product:variant-change'].forEach(function(evt){
      document.addEventListener(evt, function(){ updateGallery('event:'+evt); }, true);
    });

    $(document).on('change', 'input[name="Flavor"], input[name="Bundle & Save"]', function(){
      setTimeout(function(){ updateGallery('radios'); }, 0);
    });

    // ---------- initial paint ----------
    updateGallery('init');

    // ---------- prevent Flickity from landing on hidden cells ----------
    $carousels.off('select.flickity.hpFix').on('select.flickity.hpFix', function () {
      var $carousel = $(this);
      var flkty = $carousel.data('flickity');
      if (!flkty || !flkty.cells || flkty.selectedIndex == null) return;
      if ($carousel.data('hp-skip')) return;
      var idx = flkty.selectedIndex;
      var $sel = $(flkty.cells[idx].element);
      if ($sel.css('display') !== 'none') {
        $carousel.data('hp-last-index', idx);
        return;
      }
      var last = $carousel.data('hp-last-index');
      var len  = flkty.cells.length;
      if (typeof last !== 'number') last = idx;
      var fwd  = (idx - last + len) % len;
      var back = (last - idx + len) % len;
      var step = (back <= fwd) ? -1 : +1;
      var i = idx, tries = 0;
      while (tries++ < len) {
        i = (i + step + len) % len;
        var $cell = $(flkty.cells[i].element);
        if ($cell.css('display') !== 'none') {
          $carousel.data('hp-skip', true);
          $carousel.flickity('select', i, true, false);
          $carousel.data('hp-skip', false);
          $carousel.data('hp-last-index', i);
          break;
        }
      }
    });

    // ---------- YOTPO ----------
    let nIntervId;
    function waitingYotpoLoadPDP() { if (!nIntervId) nIntervId = setInterval(yotpoReviewsWidgetLoadedPDP, 100); }
    function yotpoReviewsWidgetLoadedPDP() {
      var y1 = $('.yotpo-widget-instance .yotpo-sr-bottom-line-text');
      var y2 = $('.yotpo-widget-instance .yotpo-bottom-line-basic-text');
      if (y1.length) formatReviewsCountNumber(y1[0], false);
      if (y2.length) formatReviewsCountNumber(y2[0], true);
    }
    function formatReviewsCountNumber(widget, isClear) {
      if (!widget) return;
      var html = $(widget).html() || '';
      if (html && (html.includes('reviews') || html.includes('Reviews'))) {
        var m = html.match(/(\d+)/);
        if (m) {
          var reviewsCount = m[1];
          if (+reviewsCount > 999) {
            var arr = ('' + reviewsCount).split('');
            arr.splice(arr.length - 3, 0, ',');
            $(widget).html(html.replace(reviewsCount, arr.join('')));
          }
          if (isClear) { clearInterval(nIntervId); nIntervId = null; }
        }
      }
    }
    if ($('.yotpo-widget-instance').length) waitingYotpoLoadPDP();
  });
})();
